export default __webpack_public_path__ + "static/media/avatar-patient.ebfe4fb8.png";